import axios from 'axios';
import { StringFormatter } from './StringFormatter';
import { Aesdecryption, Aesencryption } from '../Aes/Aes';

let cachedApiUrl = null;

const getApiUrl = async () => {
  if (cachedApiUrl) return cachedApiUrl;
  const resp = await fetch('/apiinfo.json');
  const data = await resp.json();
  cachedApiUrl = data.apipathurl;
  return cachedApiUrl;
};

const Hexapi = (props) => new Promise(async (resolve, reject) => {
  try {
    const apiUrl = await getApiUrl();
    const formattedQueryString = StringFormatter(props.query, props.queryArr);
    console.log(formattedQueryString);

    const fd = new FormData();
    fd.append(Aesencryption('Query'), Aesencryption(formattedQueryString));

    if (props.file !== undefined) {
      fd.append(Aesencryption('file'), props.file);
    }

    const resp = await axios({
      mode: 'cors',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      url: `${apiUrl}fetchrsdataV3.php`,
      data: fd,
    });

    console.log(resp.data, 'resp');
    const decrypted = Aesdecryption(resp.data);
    const parsed = JSON.parse(decrypted);
    if (parsed) {
      resolve(parsed);
    } else {
      reject('not get any response');
    }
  } catch (err) {
    console.error(`axios error in query: ${props.query}`, err);
    reject(err);
  }
});

export default Hexapi;